import type {
  ForgetUserkeyRequest,
  ForgetUserkeyResponse,
  IUserkeyMaintenanceService,
  RecoverUserRequest,
  RecoverUserResponse,
} from '../../types/serviceType';
import { GIBS_ROUTES } from '../requestsService';

const GIBS_APPLICATION = 'GIBS';

export class UserkeyMaintenanceService implements IUserkeyMaintenanceService {
  private fetch: <T = unknown>(endpoint: string, options?: RequestInit) => Promise<T>;

  constructor(fetch: <T = unknown>(endpoint: string, options?: RequestInit) => Promise<T>) {
    this.fetch = fetch;
  }

  /**
   * Lookup user info by CPF (GIBS recuperar usuario)
   */
  async postRecoverUser(request: RecoverUserRequest): Promise<RecoverUserResponse> {
    const cleanCpf = request.cpf.replace(/\D/g, '');
    const body: RecoverUserRequest = { cpf: cleanCpf };

    const response = await this.fetch<RecoverUserResponse>(GIBS_ROUTES.POST_RECOVER_USER, {
      method: 'POST',
      body: JSON.stringify(body),
    });

    return response;
  }

  /**
   * Request userkey reset (GIBS recuperar senha)
   */
  async postForgetUserkey(request: ForgetUserkeyRequest): Promise<ForgetUserkeyResponse> {
    const cleanCpf = request.cpf.replace(/\D/g, '');
    const body: ForgetUserkeyRequest = {
      cpf: cleanCpf,
      email: request.email.trim(),
      aplicacao: request.aplicacao || GIBS_APPLICATION,
    };

    const response = await this.fetch<ForgetUserkeyResponse>(GIBS_ROUTES.POST_RECOVER_PASSWORD, {
      method: 'POST',
      body: JSON.stringify(body),
    });

    return response;
  }
}
